export function closeLocalStorage(): void {
    localStorage.removeItem('typeActiviteData');
    localStorage.removeItem('activity');
    localStorage.removeItem('activityStepperState');
    localStorage.removeItem('currentTypeActiviteForEdit');
}
export function transformString(code: string): string {
    return code
    .normalize("NFD") // Décompose les caractères accentués
    .replace(/[\u0300-\u036f]/g, "") // Supprime les diacritiques (accents)
    .replace(/\s/g, "") // Supprime tous les espaces
    .toUpperCase();
}

/**
 * Transforme une chaîne de caractères de type camelCase/PascalCase en SNAKE_CASE.
 * Exemple: 'testMarche' -> 'TEST_MARCHE'
 * Exemple: 'AnotherExample' -> 'ANOTHER_EXAMPLE'
 * @param inputString La chaîne de caractères à transformer.
 * @returns La chaîne de caractères transformée en SNAKE_CASE.
 */
export function toSnakeCaseUpper(inputString: string): string {
    return inputString
        .replace(/(?<!^)([A-Z])/g, '_$1') // Insère un '_' avant chaque majuscule (sauf au début)
        .toUpperCase(); // Convertit toute la chaîne en majuscules
}

export function toCamelCase(inputString: string): string {
    return inputString.toLowerCase().replace(/_([a-z])/g, (g) => g[1].toUpperCase());
}

export function escapeRegExp(string: string) {
  return string.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
}